import React, { useContext } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { maxWidth, styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/userContext";
import GlobalStateContext from "../context/globalStateContext";
import logoImage from "../assets/logo.png";

const HeaderContainer = styled(Box)({
  width: "100%",
  padding: "16px 0",
  backgroundColor: "#000000",
});

const HeaderContent = styled(Box)(({ theme }) => ({
  maxWidth: "800px",
  width: "100%",
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0 24px",
  [theme.breakpoints.down("md")]: {
    padding: "0 0px",
    maxWidth: "95%",
  },
}));

const Logo = styled(Box)({
  display: "flex",
  // alignItems: "center",
  // fontSize: "18px",
  // fontWeight: "600",
  // color: "#FFFFFF",
  gap: "8px",
  alignItems: "center",
  cursor: "pointer",
});

const Header = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const handleMenuClick = () => {
    if (!user) {
      setGlobalState({ ...globalState, showAuthModal: true });
    } else {
      navigate(`/profile/${user.username}`);
    }
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo onClick={() => navigate("/")}>
          <img
            src={logoImage}
            alt="PledgeFast"
            style={{ width: "32px", height: "auto" }}
          />
          <Typography sx={{ fontSize: "24px", fontWeight: "600", color: "#FFFFFF" }}>
            PledgeFast
          </Typography>
        </Logo>
        <IconButton
          sx={{ color: "#FFFFFF" }}
          aria-label="menu"
          onClick={handleMenuClick}
        >
          <MenuIcon />
        </IconButton>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
